//============================
//# imbokcashflowit
//============================

export default interface CashFlowRiportGroup {
  id: number;
  head: number;
  name: string;
  remark: string;
  dateMonth: number;
  reportGroup: number;
  isProfit: boolean;
  isClosed: boolean;
  planProfitPerc: number;
  planProfitAmount: number;
}

export const CashFlowRiportGroupDefaultProps: CashFlowRiportGroup = {
  id: 0,
  head: 0,
  name: "-",
  remark: "-",
  dateMonth: 0,
  reportGroup: 0,
  isProfit: false,
  isClosed: false,
  planProfitPerc: 0,
  planProfitAmount: 0
}